import React from 'react';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import Tooltip from 'components/generic/Tooltip.component';
import CurrencySign from 'components/price/CurrencySign.component';
import FLAG from 'config/flag.singleton';
import { KPI_UNIT } from 'constants/staff/kpiUnit.const';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromNumberToFormatted from 'utils/converters/number/fromNumberToFormatted.util';
import logger from 'utils/logger.util';
import isNoValue from 'utils/predicates/any/isNoValue.util';

import CN from './ScoreAmount.module.scss';

const L = logger('ScoreAmount'); // eslint-disable-line no-unused-vars

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);

const TooltipContent = ({ t }) => (
  <div data-bem="TooltipContent" className={CN.textTooltip}>
    {t('staffKpisReports.kpiReports.scoreCard.tooltip')}
  </div>
);

const ScoreAmount = ({ unit, value }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const displayValue = fromNumberToFormatted(value);

  if (USE_SPAM_LOG) L.debug('()', unit, value, displayValue);

  return (
    <div
      data-bem="ScoreAmount"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      {isNoValue(value) ? (
        <Tooltip content={<TooltipContent t={t} />} variant="slickLeft">
          <div data-bem="ScoreAmount__missing" className={CN.flex}>
            <Icon variant="info" width="md" />
            <div className={CN.noValueText}>{t('staffKpisReports.kpiReports.scoreCard.noData')}</div>
          </div>
        </Tooltip>
      ) : (
        <div data-bem="ScoreAmount__currency">
          {unit === KPI_UNIT.currency && (
            <div>
              <CurrencySign />
              {displayValue}
            </div>
          )}
          {unit === KPI_UNIT.percent && <div data-bem="ScoreAmount__percent">{value}%</div>}
          {unit === KPI_UNIT.count && <div data-bem="ScoreAmount__count">{value}</div>}
        </div>
      )}
    </div>
  );
};

export default ScoreAmount;
